/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A contiguous run of messages in a windowed view (`risk_only` via `risk_segments`, or `query` via `match_segments`), covering one or more matches plus their surrounding context. Messages for a segment are the entries of `Chat.messages` whose `seq` falls within `[first_seq, last_seq]`.
 */
export type RiskSegment = {
  /**
   * The `seq` of the first (oldest) message in this segment.
   */
  firstSeq: number;
  /**
   * Whether messages exist after this segment within the generation. Expand with an `after_seq` request using `last_seq`.
   */
  hasMoreAfter: boolean;
  /**
   * Whether messages exist before this segment within the generation. Expand with a `before_seq` request using `first_seq`.
   */
  hasMoreBefore: boolean;
  /**
   * The `seq` of the last (newest) message in this segment.
   */
  lastSeq: number;
};

/** @internal */
export const RiskSegment$inboundSchema: z.ZodMiniType<RiskSegment, unknown> = z
  .pipe(
    z.object({
      first_seq: z.int(),
      has_more_after: z.boolean(),
      has_more_before: z.boolean(),
      last_seq: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "first_seq": "firstSeq",
        "has_more_after": "hasMoreAfter",
        "has_more_before": "hasMoreBefore",
        "last_seq": "lastSeq",
      });
    }),
  );

export function riskSegmentFromJSON(
  jsonString: string,
): SafeParseResult<RiskSegment, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskSegment$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskSegment' from JSON`,
  );
}
